import savedSearchActions from '../state/savedSearchActions.js';
import lowfareActions from '../state/lowfareActions.js';
import formActions from '../state/formActions.js';
import actions from '../state/actions.js';

import { pollQuery } from './query.js';

const searchTimeout = 20 * 1000; // Roughly matches no.finn.travel.flight.integration.route.SupplierIntegrationRoute.HYSTRIX_SEARCH_TIMEOUT
const interval = 1000;

export default function poll(resultUrl, getState, dispatch) {
    let doPoll = null; // avoid no-use-before-define

    const pollStart = new Date().getTime();

    const resultIsComplete = data => {
        if (data && data.progress) {
            return data.progress >= 100;
        }
        return false;
    };

    const pollingTimeOut = () => {
        const now = new Date().getTime();
        return now - pollStart >= searchTimeout;
    };

    const hasLowfares = data => data.lowFares && data.lowFares.length;

    const isLowfareTripType = request => (request.requestedReturnDate && request.tripType === 'roundtrip') || request.tripType === 'oneway';

    const handlePollingTimeout = data => {
        if (pollingTimeOut() || (data && resultIsComplete(data))) {
            dispatch(actions.pollingComplete());
            dispatch(lowfareActions.pollingComplete());
            dispatch(savedSearchActions.setEnabled(true));
        } else {
            setTimeout(doPoll, interval);
        }
    };

    let firstRequest = true;
    let oldProgress = 0;

    doPoll = () =>
        fetch(`${FINN.travel.contextPath}${resultUrl}?${pollQuery(getState().filterState, oldProgress, pollingTimeOut())}`, {
            method: 'GET',
            cache: 'no-cache',
        })
            .then(response => (response.status >= 200 && response.status < 300 ? response.json() : Promise.reject()))
            .then(data => {
                if (data) {
                    oldProgress = data.progress;
                    dispatch(actions.setResultData(data));
                    if (firstRequest && data.request) {
                        firstRequest = false;
                        dispatch(actions.requestReceived(data.request));
                        dispatch(formActions.requestReceived(data.request));
                        dispatch(savedSearchActions.requestReceived(data.request));
                    }
                    if (hasLowfares(data) && isLowfareTripType(data.request)) {
                        dispatch(lowfareActions.setCalendarData(data));
                    }
                }
                handlePollingTimeout(data);
            })
            .catch(() => {
                // Also handles 304 Not Modified for identical results,
                // see no.finn.travel.flight.storage.client.StatusBuilder.statusMessageIfUpdated
                handlePollingTimeout();
            });

    setTimeout(doPoll, interval);
}
